// Centralized event name constants and helpers for Analytics

export const ANALYTICS_EVENTS = {
  PAGE_VIEW: 'page_view',
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  // Legacy posts feature events: retained for backward compatibility with existing production data; remove once Records fully replace posts.
  LIKE_POST: 'like_post',
  UNLIKE_POST: 'unlike_post',
  COMMENT_POST: 'comment_post',
  SHARE_POST: 'share_post',
  SAVE_POST: 'save_post',
  UNSAVE_POST: 'unsave_post',
  CREATE_POST: 'create_post',
  FRIEND_REQUEST_SENT: 'friend_request_sent',
  FRIEND_REQUEST_ACCEPTED: 'friend_request_accepted',
  PROFILE_UPDATE: 'profile_update',
  SEND_MESSAGE: 'send_message',
  SEND_GROUP_MESSAGE: 'send_group_message',
  // Add more as needed
};

// Optionally, you can add helper functions for common event parameter structures here.
